import { render, staticRenderFns } from "./gtest.vue?vue&type=template&id=6ce9a8d6&scoped=true&"
import script from "./gtest.vue?vue&type=script&lang=js&"
export * from "./gtest.vue?vue&type=script&lang=js&"
import style0 from "./gtest.vue?vue&type=style&index=0&id=6ce9a8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9a8d6",
  null
  
)

export default component.exports